export default "__VITE_ASSET__D8g6YwHV__"